import { Request } from "./lib/request";
import { getStoreData, storeData } from "./lib/store";

$(async () => {
	const enqueteId = $("#enqueteId").val() as string;
	const monitorId = getStoreData(enqueteId);
	const url = location.pathname;
	try {
		// userIdの発行。
		const response = (await Request.postJson(url, { enqueteId, monitorId })) as {
			monitorId?: number;
			location: string;
		};
		console.log(response);
		if (response.monitorId) {
			storeData(enqueteId, response.monitorId.toString());
		}
		location.replace(response.location);
	} catch (e) {
		console.log(e);
		alert("エラーが発生しました。再度リロードしてください。");
	}
});
